CourtService.$inject = ["_"];

/* @ngInject */
function CourtService(_) {
  var courtCache = {};

  var attrs = [
      "id",
      "name",
      "attributes",
      "order",
      "price_base",
      "price_modifiers",
      "round_start",
      "state",
      "sports",
      "parent_id",
      "cancellation_policy_id",
      "advance",
      "capture",
      "disclaimer",
      "beelup_court_status",
      "sportclub_beelup_status",
      "advance_type"
    ],
    defaults = {
      price_base: 0,
      round_start: false,
      parent_id: null,
      cancellation_policy_id: null,
    };

  /**
   * Court class
   * @class Court
   */
  function Court(payload) {
    _.assign(this, _.defaults(_.pick(payload, attrs), defaults));
    this._calculateDivisible();
  }

  /**
   * Merge new updated attributes
   * @method attrs
   * @param  {object} payload
   * @chainable
   */
  Court.prototype.attrs = function(payload) {
    _.assign(this, _.pick(payload, attrs));
    return this;
  };

  Court.prototype.getSports = function() {
    return this.sports;
  };
  Court.prototype.getSportsIds = function() {
    return _(this.sports)
      .mapValues("id")
      .values()
      .value();
  };

  Court.prototype._calculateDivisible = function() {
    this.divisible = _(this.sports)
      .mapValues("divisible_duration")
      .values()
      .min();
  };

  /**
   * Calculates the price
   * @method price
   * @param  {int} dow Day of Week
   * @param  {float} start_hour Start hour in float format
   * @param  {int} duration Duration in minutes
   * @return {int}
   */
  Court.prototype.price = function(dow, start_hour, duration) {
    var base = this.price_base || 0,
      modifiers = this.price_modifiers || {};

    if (!modifiers) {
      return 0;
    }

    var day = _.has(modifiers, dow) ? modifiers[dow] : modifiers["*"];

    var hour = _.chain(day)
      .keys()
      .without("*")
      .sort()
      .find(function(h) {
        return parseFloat(h) > start_hour;
      })
      .value();

    hour = hour ? day[hour] : day["*"];

    // Durations
    var duration_price = _.has(hour, duration)
      ? hour[duration]
      : hour[_.keys(hour)[0]]; // If there's no duration. use smallest duration

    return duration_price;
  };

  /**
   * Get's eveny court that has it's id as parent_id.
   * Returns empty array if it has no children.
   * Returns false if it's itself a child.
   *
   * @method getChildren
   * @return {array} Court array
   */
  Court.prototype.getChildren = function() {
    var self = this;

    return Court.list(function(c) {
      return c.parent_id === self.id;
    });
  };

  /**
   * Mutates that object into a Court instance
   * @method Court.create
   * @param  {object} payload Raw court object (properties)
   * @return {Court} New instance
   */
  Court.create = function(payload, api) {
    var instance,
      data = payload.plain ? payload.plain() : payload;

    if (courtCache.hasOwnProperty(data.id)) {
      instance = courtCache[data.id].attrs(data);
    } else {
      instance = new Court(data);
      courtCache[instance.id] = instance;
    }

    if (api) {
      instance.api = payload;
    }
    return instance;
  };

  /**
   * Mutates an entire array into a collection of Court instances
   * @method Court.collect
   * @param  {array} courts
   * @return {array}
   */
  Court.collect = function(courts, api) {
    courts = courts.plain && !api ? courts.plain() : courts;
    return _.map(courts, function(court) {
      return Court.create(court, api);
    });
  };

  /**
   * Returns a court if it's in the cache or undefined
   * @method get
   * @param  {number} id
   * @return {Court}
   */
  Court.get = function(id) {
    return courtCache[id];
  };

  /**
   * Lists every court
   * @method list
   * @paran {function} filter Optional filter function
   * @return {array} Array of Court
   */
  Court.list = function(filter) {
    var chain = _(courtCache);

    if (filter) {
      chain = chain.filter(filter);
    }

    return chain
      .map(function(court) {
        return _.pick(court, ["id", "name"]);
      })
      .value();
  };

  return Court;
}

export default CourtService;
